import * as tslib_1 from "tslib";
import { Component, Vue } from "vue-property-decorator";
import { addMediaGroup, deleteAudio, deleteMediaGroup, editMediaGroup, getMediaGroups, getPlayerUrl, getGraphocList, changeGraphicStatus } from "@/api/material";
let GraohicManage = class GraohicManage extends Vue {
    constructor() {
        super(...arguments);
        this.search = {
            title: '',
            status: '' // 1已上架 0未上架
        };
        this.mediaGroups = []; // 音频分组列表
        this._groupCache = null; // 当前操作分组缓存
        this.currentGroupId = 0; // 当前操作分组ID
        this.audioList = []; // 音频列表
        this.isAudioLoading = false; // 音频列表加载状态
        // 音频列表分页器
        this.audioPaginator = {
            pageNo: 1,
            pageSize: 15,
            total: 0,
        };
        // 音频播放器
        this.audioPlayer = {
            isVisible: false,
            src: "",
        };
    }
    created() {
        this.initGroupData();
        this.getAudioList();
    }
    // 加载分组信息
    async initGroupData() {
        const res = await getMediaGroups(3);
        if (res.data.status !== 200)
            return;
        const data = res.data.data;
        if (!data)
            return;
        this.mediaGroups = [
            // 默认全部音频置顶
            {
                id: 0,
                name: "全部图文",
                _name: "全部图文",
                isEdit: false,
            },
            ...data.map((group) => {
                return {
                    id: group.id,
                    name: group.name,
                    _name: group.name,
                    isEdit: false,
                };
            }),
        ];
    }
    onChangeStatus(props) {
        this.$confirm(`是否要${props.status == 1 ? '停用' : '启用'}？`, "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
        }).then(async () => {
            let data = {
                idList: [props.id],
                status: props.status == 1 ? 0 : 1
            };
            const res = await changeGraphicStatus(data);
            if (res.data.status !== 200)
                return this.$message.error(res.data.msg);
            this.$message({
                type: 'success',
                message: '修改成功'
            });
            this.getAudioList();
        });
    }
    // 新增分组
    handleGroupAdd() {
        this.$prompt("请输入分组名称", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            inputErrorMessage: "",
            inputValidator(value) {
                // 校验分组名称
                if (value.trim() === '') {
                    return "分组名称不能为空";
                }
                if (value.length > 20) {
                    return "分组名称限制20个字符";
                }
                if (value === "全部音频") {
                    return "不能命名为全部音频";
                }
                return true;
            },
        })
            .then(async (data) => {
            const name = data.value;
            const res = await addMediaGroup(name, 3);
            if (res.data.status !== 200)
                return;
            this.initGroupData();
        })
            .catch(() => {
            // this.$message.info("操作取消");
        });
    }
    handleGroupCancel(group) {
        this._groupCache = null;
        group.isEdit = false;
        group.name = group._name;
    }
    // 编辑分组
    handleGroupEdit(group) {
        if (this._groupCache) {
            this._groupCache.isEdit = false;
        }
        console.log(this._groupCache, group);
        group.isEdit = true;
        this._groupCache = group;
    }
    // 保存分组（编辑）
    async handleGroupSave(group) {
        // 【全部音频】分组禁止编辑
        if (group._name === "全部音频") {
            return this.$message.error("不能命名全部音频");
        }
        // 校验分组名称
        if (!group.name) {
            return this.$message.error("分组名称为空");
        }
        if (group.name.length > 20) {
            return this.$message.error("分组名称限制20个字符");
        }
        if (group.name === "全部音频") {
            return this.$message.error("不能命名为全部音频");
        }
        const res = await editMediaGroup(group.id, group.name);
        if (res.data.status !== 200)
            return;
        group.isEdit = false;
        group._name = group.name;
        this._groupCache = null;
    }
    // 删除分组
    handleGroupDelete(group) {
        this.$confirm("此操作将永久删除该分组, 是否继续?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
        })
            .then(async () => {
            const res = await deleteMediaGroup(group.id);
            if (res.data.status !== 200)
                return;
            // 如果当前分组被删除 则跳转到【全部音频】分组
            if (group.id === this.currentGroupId) {
                this.handleGroupClick(0);
            }
            this.initGroupData();
            this.$message.success("删除成功!");
        })
            .catch(() => {
            // this.$message.info("操作取消");
        });
    }
    onSearch() {
        console.log(1122);
        this.audioPaginator.pageNo = 1;
        this.getAudioList();
    }
    // 获取音频列表
    async getAudioList() {
        this.isAudioLoading = true;
        const res = await getGraphocList({
            pageNo: this.audioPaginator.pageNo,
            pageSize: this.audioPaginator.pageSize,
            title: this.search.title,
            status: this.search.status,
            groupId: this.currentGroupId
        });
        if (res.data.status !== 200)
            return;
        const data = res.data.data;
        if (!data)
            return;
        data.list.map((item) => {
            item.courseVOS = item.courseVOS || [];
        });
        this.audioList = data.list || [];
        this.audioPaginator.pageNo = Number(data.pageNum);
        this.audioPaginator.total = Number(data.total);
        this.isAudioLoading = false;
    }
    // 音频列表换页
    handleAudioPageChange(pageNo) {
        this.audioPaginator.pageNo = pageNo;
        this.getAudioList();
        // 滚动音频列表置顶再刷新数据
        // scrollTop(
        //   document.getElementsByClassName("app-main")[0],
        //   0,
        //   233,
        //   this.getAudioList
        // );
    }
    changePageSize(pageSize) {
        this.audioPaginator.pageSize = pageSize;
        this.getAudioList();
    }
    // 点击分组
    handleGroupClick(id) {
        if (this.currentGroupId === id)
            return;
        this.currentGroupId = id;
        this.audioPaginator.pageNo = 1;
        this.getAudioList();
        // 滚动音频列表置顶再刷新数据
        // scrollTop(
        //   document.getElementsByClassName("app-main")[0],
        //   0,
        //   233,
        //   this.getAudioList
        // );
    }
    // 播放音频（点击音频名片）
    async showAudioPlayer(id) {
        console.log(id);
        const res = await getPlayerUrl(id);
        if (res.data.status !== 200)
            return;
        const data = res.data.data;
        // 校验是否成功获取音频播放地址
        if (!data)
            return this.$message.error("初始化失败");
        this.audioPlayer = {
            isVisible: true,
            src: data,
        };
    }
    // 销毁音频播放器
    destroyAudioPlayer() {
        this.audioPlayer = {
            isVisible: false,
            src: "",
        };
    }
    // 删除音频
    handleAudioDelete(id) {
        this.$confirm("确定删除该条音频吗？", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
        }).then(async () => {
            const res = await deleteAudio(id);
            if (res.data.status !== 200)
                return;
            this.$message.success("删除成功!");
            this.getAudioList();
        });
    }
    onAdd(props) {
        this.$router.push({ path: '/data-manager/graphic/edit', query: {
                id: props ? props.id : undefined,
                groupId: this.currentGroupId.toString()
            } });
    }
    onJump(props) {
        if (props.courseType == 1) {
            // 专栏
            this.$router.push({ path: '/course-manager/columnAdd', query: {
                    id: props.id
                } });
        }
        else {
            // 训练营
            this.$router.push({ path: '/course-manager/termAdd', query: {
                    id: props.id,
                    campId: props.campId
                } });
        }
    }
    onDel(props) {
        this.$confirm("确定删除该图文？", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
        }).then(async () => {
            const res = await deleteAudio(props.id);
            if (res.data.status !== 200)
                return;
            this.$message.success("删除成功!");
            this.getAudioList();
        });
    }
};
GraohicManage = tslib_1.__decorate([
    Component({ name: "GraohicManage" })
], GraohicManage);
export default GraohicManage;
